module.exports = __webpack_public_path__ + "img/goal-three-en.1cebfd41.png";